import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import aishoonteo from '../assets/aishoonteo.png';
import logo2 from '../assets/logo2.png';


class SeminarAishoonteo extends Component {

  render() {

    return (
      <div className='BioSantis'>
        <h1>Member's Details</h1>
        <img className='santis' src={aishoonteo}></img>
        <h2>MS.AI SHOON TEO</h2>
        <br />
        <div>
        COUNTRY : SINGAPORE
        </div>
        <br />

        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default SeminarAishoonteo;
